var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveAddCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "#710D0D",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99987 5.68433C9.22878 5.68433 9.41435 5.86989 9.41435 6.0988V8.58564H11.9012C12.1301 8.58564 12.3157 8.77121 12.3157 9.00012C12.3157 9.22902 12.1301 9.41459 11.9012 9.41459H9.41435V11.9014C9.41435 12.1303 9.22878 12.3159 8.99987 12.3159C8.77096 12.3159 8.5854 12.1303 8.5854 11.9014V9.41459H6.09856C5.86965 9.41459 5.68408 9.22902 5.68408 9.00012C5.68408 8.77121 5.86965 8.58564 6.09856 8.58564H8.5854V6.0988C8.5854 5.86989 8.77096 5.68433 8.99987 5.68433Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveAddCoin);
export default __webpack_public_path__ + "static/media/live-add-coin.44eac3c37f67bcd8cfc9321517feb9c1.svg";
export { ForwardRef as ReactComponent };